import { RouteName } from '../../router';
import { RoleMap } from '@/models/config';

export const NAVQUICK_LIST = [
    {
        id: 'home',
        name: '首页',
        link: '/?isHome=1',
        routeName: RouteName.Home,
    },
    {
        id: 'follow',
        name: '我的关注',
        link: '/myFollow',
        routeName: RouteName.Like,
        role: RoleMap.Like,
    },
    {
        id: 'new-reco',
        name: '推荐',
        class: 'new-reco',
        link: '/new-reco',
        routeName: RouteName.NewReco,
        role: RoleMap.NewReco,
        guideInfo: {
            title: '精彩推荐更懂你',
            text: '精彩视频沉浸体验，试试看吧~',
            btnText: '知道了',
        },
        showGuide: false,
    },
    {
        id: 'brilliant',
        name: '短视频',
        link: '/brilliant',
        routeName: RouteName.Brilliant,
        role: RoleMap.Brilliant,
    },
    {
        id: 'live',
        name: '直播',
        link: 'https://live.kuaishou.com/',
        role: RoleMap.GameLive,
    },
    {
        id: 'one',
        name: '同城',
        link: '/samecity',
        routeName: RouteName.SameCity,
        role: RoleMap.SameCity,
    },
    {
        id: 'mini',
        name: '小剧场',
        link: '/theater/0',
        routeName: RouteName.Theater,
        role: RoleMap.Theater,
    },
    {
        id: 'acfun',
        name: 'AcFun',
        link: 'https://www.acfun.cn/',
        role: RoleMap.Acfun,
    },
];
export const NAVQUICK_MIN_LIST = [
    {
        id: 'home',
        name: '首页',
        link: '/?isHome=1',
        routeName: RouteName.Home,
    },
    {
        id: 'router',
        name: '导航',
        link: '',
        children: [
            {
                id: 'follow',
                name: '我的关注',
                link: '/myFollow',
                routeName: RouteName.Like,
                role: RoleMap.Like,
            },
            {
                id: 'new-reco',
                name: '推荐',
                link: '/new-reco',
                routeName: RouteName.NewReco,
                role: RoleMap.NewReco,
            },
            {
                id: 'brilliant',
                name: '短视频',
                link: '/brilliant',
                routeName: RouteName.Brilliant,
                role: RoleMap.Brilliant,
            },
            {
                id: 'live',
                name: '直播',
                link: 'https://live.kuaishou.com/',
                role: RoleMap.GameLive,
            },
            {
                id: 'one',
                name: '同城',
                link: '/samecity',
                routeName: RouteName.SameCity,
                role: RoleMap.SameCity,
            },
            {
                id: 'mini',
                name: '小剧场',
                link: '/theater/0',
                routeName: RouteName.Theater,
                role: RoleMap.Theater,
            },
            {
                id: 'acfun',
                name: 'AcFun',
                link: 'https://www.acfun.cn/',
                role: RoleMap.Acfun,
            },
        ],
    },
];
export const NAVQUICK_MEDIUM_LIST = [
    {
        id: 'home',
        name: '首页',
        link: '/?isHome=1',
        routeName: RouteName.Home,
    },
    {
        id: 'follow',
        name: '我的关注',
        link: '/myFollow',
        routeName: RouteName.Like,
        role: RoleMap.Like,
    },
    {
        id: 'new-reco',
        name: '推荐',
        link: '/new-reco',
        routeName: RouteName.NewReco,
        role: RoleMap.NewReco,
    },
    {
        id: 'brilliant',
        name: '短视频',
        link: '/brilliant',
        routeName: RouteName.Brilliant,
        role: RoleMap.Brilliant,
    },
    {
        id: 'router',
        name: '全部',
        link: '',
        children: [
            {
                id: 'live',
                name: '直播',
                link: 'https://live.kuaishou.com/',
                role: RoleMap.GameLive,
            },
            {
                id: 'one',
                name: '同城',
                link: '/samecity',
                routeName: RouteName.SameCity,
                role: RoleMap.SameCity,
            },
            {
                id: 'mini',
                name: '小剧场',
                link: '/theater/0',
                routeName: RouteName.Theater,
                role: RoleMap.Theater,
            },
            {
                id: 'acfun',
                name: 'AcFun',
                link: 'https://www.acfun.cn/',
                role: RoleMap.Acfun,
            },
        ],
    },
];
